// extracted by mini-css-extract-plugin
export default {"tab":"ConnectionLinksComponent_tab__oibHo","copy":"ConnectionLinksComponent_copy__dYO47"};